import React, { useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import { Spinner } from "@jobber/components/Spinner";
import EditableText from "../../../components/Common/EditableText";
import { MdInfoOutline } from "react-icons/md";
import { ImBin } from "react-icons/im";
import { FiEdit } from "react-icons/fi";
import { IoMdSave } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import CustomTooltip from "./CustomTooltip";
import Tag from "./Tag";
import downFill from "../../../assets/icons/downFill.svg";
import sideFill from "../../../assets/icons/sideFill.svg";

const Category = ({
  name,
  index,
  description,
  isExclusive,
  tags,
  moveTag,
  id,
  setDeleteObject,
  isEditing,
  setEditing,
  cancelEditing,
  deleteTag,
  sameTagsClickHandler,
  moveCategory,
  handleRearrangeCategoriesEnd,
  isShow,
  handleToggle,
  userTags,
  canManageCategories,
}) => {
  const [, drop] = useDrop(() => ({
    accept: "tag",
    canDrop: () => !!canManageCategories,
    drop: () => ({ category: name, cid: id }),
  }), [name, id, canManageCategories]);

  const [{ isDragging }, drag] = useDrag(() => ({
    type: "category",
    canDrag: () => !!canManageCategories,
    item: { index },
    end: () => {
      handleRearrangeCategoriesEnd();
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }), [index, handleRearrangeCategoriesEnd, canManageCategories]);

  const [, catDrop] = useDrop(() => ({
    accept: "category",
    canDrop: () => !!canManageCategories,
    hover: (item) => {
      if (item.index !== index) {
        moveCategory(item.index, index);
        item.index = index;
      }
    },
  }), [index, moveCategory, canManageCategories]);

  const [save, setSaveHandler] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <div ref={drop}>
      <div
        ref={(node) => drag(catDrop(node))}
        style={{
          width: '100%',
          display: 'grid',
          gap: '5px',
          gridTemplateColumns: 'auto 1fr',
          opacity: isDragging ? 0 : 1,
          height: isDragging ? "1px" : "inherit",
        }}
      >
        <div className="d-flex align-items-center gap-1">
          <img
            src={isShow ? downFill : sideFill}
            className="me-2 pointer"
            width="15rem"
            onClick={() => handleToggle(id)}
            alt="toggle"
          />
          <EditableText
            onClick={() => handleToggle(id)}
            initialText={name}
            des={description}
            isExclusive={isExclusive}
            id={id}
            isEditing={isEditing}
            cancelEditing={cancelEditing}
            save={save}
            setLoading={setLoading}
            setSaveHandler={setSaveHandler}
            numberOfTags={tags.length}
          />
          {description && (
            <CustomTooltip text={description}>
              <MdInfoOutline className="fs-6 pointer" />
            </CustomTooltip>
          )}
        </div>
        <div className="d-flex justify-content-end align-items-center gap-2">
          {canManageCategories && isEditing ? (
            loading ? (
              <Spinner size="small" />
            ) : (
              <IoMdSave
                className="fs-5 pointer"
                title="save"
                onClick={() => {
                  setSaveHandler(true);
                  setLoading(true);
                }}
              />
            )
          ) : canManageCategories ? (
            <FiEdit className="pointer" onClick={setEditing} />
          ) : null}
          {canManageCategories && (
            <>
              <ImBin
                className="pointer text-danger"
                onClick={() => setDeleteObject({ open: true, name, id })}
              />
              {isEditing && <IoClose className="fs-5 pointer" onClick={cancelEditing} />}
            </>
          )}
        </div>
      </div>
      {
        isShow && (
          <div className="row mt-3 mb-2">
            {tags.map((tag) => (
              <div
                className="col-auto d-flex mb-2"
                style={{ marginRight: "-25px", position: "relative" }}
                key={tag._id}
              >
                {canManageCategories && isEditing && (
                  <div
                    className="border rounded"
                    onClick={() => deleteTag({ tagId: tag._id, catId: id, userTags })}
                  >
                    <IoClose className="fs-6 pointer text-danger" />
                  </div>
                )}
                <Tag
                  tag={tag}
                  source={name}
                  moveTag={moveTag}
                  canManageCategories={canManageCategories}
                  categoryId={id}
                  sameTagsClickHandler={sameTagsClickHandler}
                  userTags={userTags}
                />
              </div>
            ))}
          </div>
        )
      }
      {!isShow && <div className="mb-3"></div>}
    </div >
  );
};

export default Category;
